import type { ViewJobModule } from './types/ViewJobNativeModule';

import TypedNativeModules from '../../shared/native-modules/internal/TypedNativeModules';

/**
 * Entry point for accessing the native module
 *
 * Do not access the react-native NativeModules object directly outside of this method.
 *
 * CAUTION: This is fake type-safety. It assumes the native modules are defined correctly.
 */
export function viewJobNativeModule(): ViewJobModule {
    return TypedNativeModules.ViewJobModule;
}
